export const PATH = {
  HOME: '/',
  AUTH: 'auth',
  LOGIN: 'login',
  SIGN_UP: 'sign-up',
  RESET_PASSWORD: 'resetpassword',
  DISCOVER: 'discover',
  CHANNELS: 'channels',
  BOOKMARKS: 'bookmarks',
  EVENTS: 'events',
  RELEASES: 'releases',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',
  SUBSCRIPTIONS: 'subscriptions',
  COLLECTIONS: 'collections',
  HELP: 'help',
  TERMS: 'terms',
  PRIVACY: 'privacy',
};

export type MODAL_KEYS = 'EDIT_PROFILE' | 'WALLET' | 'SHARE' | 'CREATE_CHANNEL';

export type MODALS_MAP = { [key in MODAL_KEYS]: string };

export const MODALS: MODALS_MAP = {
  EDIT_PROFILE: 'edit profile',
  WALLET: 'wallet',
  SHARE: 'share',
  CREATE_CHANNEL: 'create channel',
};

export type OVERLAY_KEYS = 'EVENT' | 'SOCIAL_FEED' | 'NEWS_FEED' | 'CHANNEL';

export type OVERLAYS_MAP = { [key in OVERLAY_KEYS]: string };

export const OVERLAYS: OVERLAYS_MAP = {
  NEWS_FEED: 'news feed',
  SOCIAL_FEED: 'social feed',
  EVENT: 'event',
  CHANNEL: 'channel',
};

export const MARKETPLACE_URL = 'https://marketplace.holdr.club';
